


import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, EMPTY } from 'rxjs';
import { tap, map, switchMap, take, catchError, withLatestFrom, filter, concatMap, mergeMap } from 'rxjs/operators';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { Store, select } from '@ngrx/store';
import { get, mergeWith } from 'lodash';

import { getValue } from '@app/shared/utils/feature-utils';
import * as fromStore from '@app/core/store';
import * as fromMaster from '../store/master-perfil-acesso.actions';
import { ActionHandler } from '@app/core/components/actions/action.handler';
import { MessagesService } from '@app/core/services/messages/message.service';
import { AnteriorAction } from '../actions/master-anterior-perfil-acesso.action';
import { ProximoAction } from '../actions/master-proximo-perfil-acesso.action';
import { environment } from '@env/environment';
const BASE_PATH = environment.basePath;

@Injectable()
export class MasterPerfilAcessoEffects {
  constructor(
    private actions$: Actions,
    private actionHandler: ActionHandler,
    private store: Store<fromStore.State>,
    private message: MessagesService,
    private httpClient: HttpClient,
    private anteriorAction: AnteriorAction,
    private proximoAction: ProximoAction,
  ) { }

  initValueService = (payload: any) => {
    const code = payload.code;
    if (typeof code === "undefined") {
      return of({})
        ;
    }
    if (payload.parentCtx && payload.parentCtx.roleName) {
      return this.store.select(fromStore.selectRoleValue, {
        ...payload.parentCtx,
        code
      });
    } else {

      return of({})
        ;
    }
  };

  initValue$ = createEffect((): any =>
    this.actions$.pipe(
      ofType(fromMaster.initValueAction),
      switchMap(payload => {
        return this.initValueService(payload).pipe(
          map(
            result =>
              fromMaster.initValueSuccessAction({
                ...payload,

                result

              })
          ),
          catchError(error =>
            of(fromMaster.initValueFailAction({ ...payload, error }))
          )
        );
      }))
  );

  fetchtypeclientsPossibleValues$ = createEffect(() => this.actions$.pipe(
    ofType(fromMaster.fetchFieldPossibleValuesAction),
    filter(payload => payload.field === 'typeclients'),
    switchMap(payload => {
      return of([])

        .pipe(
          map(
            result =>
              fromMaster.fetchFieldPossibleValuesSuccessAction({
                ...payload,
                possibleValues: result,
                field: payload.field,
                separator: '|',
                keys: []
              })
          ),
          catchError(err =>
            of(fromMaster.fetchFieldPossibleValuesFailAction({}))
          )
        );
    })
  )
  );






  anteriorAction$ = createEffect((): any =>
    this.actions$.pipe(
      ofType(fromMaster.anteriorAction),
      switchMap(payload => {
        return this.actionHandler.perform(this.anteriorAction, payload).pipe(
          map(result =>
            fromMaster.anteriorSuccessAction({ ...payload, data: result })
          ),
          catchError(error => of(fromMaster.anteriorFailAction({ ...payload })))
        );
      })
    )
  );

  navigateAfteranterior$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromMaster.anteriorAction),
      map((context: any) => {
        context['path'] = '/master/CriarUsuario';
        context['navigationType'] = 'switch';
        context['feature'] = 'master';
        context['screen'] = 'CriarUsuario';
        context['queryParams'] = {};
        return fromStore.navigateBySwitchAction(context);

      })
    ));


  proximoAction$ = createEffect((): any =>
    this.actions$.pipe(
      ofType(fromMaster.proximoAction),
      switchMap(payload => {
        return this.actionHandler.perform(this.proximoAction, payload).pipe(
          map(result =>
            fromMaster.proximoSuccessAction({ ...payload, data: result })
          ),
          catchError(error => of(fromMaster.proximoFailAction({ ...payload })))
        );
      })
    )
  );







}


